import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { IFilterParams, IDoesFilterPassParams, RowNode, ValueGetterParams } from 'ag-grid-community';

interface DateFilterParams extends IFilterParams {
	valueGetter: (params: ValueGetterParams<any, any>) => any;
  }

@Component({
    selector: 'app-date-filter',
    templateUrl: './date-filter.component.html',
    styleUrls: ['./date-filter.component.scss'],
    standalone: false
})
export class DateFilterComponent {
	private params: DateFilterParams;
	private valueGetter: (params: ValueGetterParams<any, any>) => any;

	public text: string = '';
	public hideFilter;
	selectedFromDate;
	selectedToDate;


	@ViewChild('input', { read: ViewContainerRef }) public input;

	agInit(params: IFilterParams): void {
		this.params = params as DateFilterParams
		this.valueGetter = this.params.valueGetter;
	}

	isFilterActive(): boolean {
		return this.text != null && this.text != '';  // NOSONAR
	}

	afterGuiAttached(params) {
		this.hideFilter = params.hidePopup
	}
	
	closeDialog() {
		
		this.dialogRef.close({ event: "close" });
	}

	constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<DateFilterComponent>) { }

	ngOnInit(): void {
		console.info("something")
	}

	submit(){
		this.dialogRef.close({ event: "submit" });
	}

}
